/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_Meta_TitleInputs */

const id_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik rilis - egdata.app`)
};

const ms_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik keluaran - egdata.app`)
};

const da_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivelsesstatistik - egdata.app`)
};

const de_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsstatistiken - egdata.app`)
};

const en_us2_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releases stats - egdata.app`)
};

const es_es2_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos - egdata.app`)
};

const es_mx2_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos - egdata.app`)
};

const fil_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng Release - egdata.app`)
};

const fr_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de sorties - egdata.app`)
};

const it_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche uscite - egdata.app`)
};

const hu_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenési statisztikák - egdata.app`)
};

const nl_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasestatistieken - egdata.app`)
};

const no_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivelsesstatistikk - egdata.app`)
};

const pl_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki wydań - egdata.app`)
};

const pt_br2_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamentos - egdata.app`)
};

const pt_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamentos - egdata.app`)
};

const ro_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici lansări - egdata.app`)
};

const fi_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisutilastot - egdata.app`)
};

const sv_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släppstatistik - egdata.app`)
};

const vi_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê phát hành - egdata.app`)
};

const tr_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış istatistikleri - egdata.app`)
};

const cs_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky vydání - egdata.app`)
};

const bg_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на издаванията - egdata.app`)
};

const ru_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релизов — egdata.app`)
};

const uk_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релізів - egdata.app`)
};

const ar_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات الإصدارات - egdata.app`)
};

const hi_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ आँकड़े - egdata.app`)
};

const th_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติการวางจำหน่าย - egdata.app`)
};

const ja_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース統計 - egdata.app`)
};

const zh_cn2_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布统计 - egdata.app`)
};

const zh_hant1_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發布統計 - egdata.app`)
};

const ko_stats_releases_meta_title = /** @type {(inputs: Stats_Releases_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 통계 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Releases stats - egdata.app" |
*
* @param {Stats_Releases_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_meta_title = /** @type {((inputs?: Stats_Releases_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_meta_title(inputs)
	if (locale === "ms") return ms_stats_releases_meta_title(inputs)
	if (locale === "da") return da_stats_releases_meta_title(inputs)
	if (locale === "de") return de_stats_releases_meta_title(inputs)
	if (locale === "en-US") return en_us2_stats_releases_meta_title(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_meta_title(inputs)
	if (locale === "fil") return fil_stats_releases_meta_title(inputs)
	if (locale === "fr") return fr_stats_releases_meta_title(inputs)
	if (locale === "it") return it_stats_releases_meta_title(inputs)
	if (locale === "hu") return hu_stats_releases_meta_title(inputs)
	if (locale === "nl") return nl_stats_releases_meta_title(inputs)
	if (locale === "no") return no_stats_releases_meta_title(inputs)
	if (locale === "pl") return pl_stats_releases_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_meta_title(inputs)
	if (locale === "pt") return pt_stats_releases_meta_title(inputs)
	if (locale === "ro") return ro_stats_releases_meta_title(inputs)
	if (locale === "fi") return fi_stats_releases_meta_title(inputs)
	if (locale === "sv") return sv_stats_releases_meta_title(inputs)
	if (locale === "vi") return vi_stats_releases_meta_title(inputs)
	if (locale === "tr") return tr_stats_releases_meta_title(inputs)
	if (locale === "cs") return cs_stats_releases_meta_title(inputs)
	if (locale === "bg") return bg_stats_releases_meta_title(inputs)
	if (locale === "ru") return ru_stats_releases_meta_title(inputs)
	if (locale === "uk") return uk_stats_releases_meta_title(inputs)
	if (locale === "ar") return ar_stats_releases_meta_title(inputs)
	if (locale === "hi") return hi_stats_releases_meta_title(inputs)
	if (locale === "th") return th_stats_releases_meta_title(inputs)
	if (locale === "ja") return ja_stats_releases_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_meta_title(inputs)
	return ko_stats_releases_meta_title(inputs)
});
export { stats_releases_meta_title as "stats.releases.meta.title" }